import React from "react"
import PlayerCounters from "./PlayerCounters"

function PlayerCountersOpponent(props) {
    return (<PlayerCounters
        profileData={props.profileData}
        counters={props.counters}
        opponentIndex={props.opponentIndex}
        tokens={props.tokens}
        tokensAvailable={props.tokensAvailable}
        notes={props.notes}
        setIsTextInputFocused={props.setIsTextInputFocused}
        playerId={props.playerId}
        actionMode={props.actionMode}
        createLinkTo={props.createLinkTo}
    />)
}

function areEqual(prevProps, nextProps) {
    return prevProps.refreshCount === nextProps.refreshCount &&
    prevProps.actionMode.actionData === nextProps.actionMode.actionData
}

export default React.memo(PlayerCountersOpponent, areEqual)